import { trackCheckoutProgress } from '../../../../../../shared/analytics/e-commerce/trackCheckoutProgress';
import { trackViewItemList } from '../../../../../../shared/analytics/e-commerce/trackViewItemList';
import { flatten } from '../../../../../../shared/utils/flatten';
import { IAncillary } from '../../../../../domain/ancillary/domain/models/IAncillary';
import { adaptAncillaryToItems } from './adapters/adaptAncillaryToItems';
import { CheckoutSteps } from './CheckoutSteps';

export function trackViewAncillaries(ancillaries: IAncillary[]) {
	const nestedItems = ancillaries.map(adaptAncillaryToItems);

	trackViewItemList({
		items: flatten(nestedItems),
	});

	trackCheckoutProgress({
		step: CheckoutSteps.SelectExtras,
	});
}
